"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultAppData = {
  "settings": {
    "basic_settings": {
      "name": {
        "lang_1": "SA Development 1.",
        "lang_2": "SA Development 1."
      },
      "short_name": {
        "lang_1": "SA Development 1.",
        "lang_2": "SA Development 1."
      },
      "description": {
        "lang_1": "Project leírás, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "lang_2": "Project description, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      },
      "logo": {
        "disable": false,
        "image_url": {
          "light": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect style='fill:%23033246;' x='45' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23033246;' x='45' y='47' width='311' height='16.188'/%3E%3Crect style='fill:%23033246;' x='339.812' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23033246;' x='45' y='341.812' width='311' height='16.188'/%3E%3Ccircle style='fill:%23033246;' cx='348' cy='202' r='44'/%3E%3Cpath style='fill:%23033246;' d='M234,286l72,57H234V286Z'/%3E%3Cpath style='fill:%23033246;' d='M134,122l72-73H134v73Z'/%3E%3C/svg%3E",
          "dark": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect style='fill:%23ffffff;' x='45' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23ffffff;' x='45' y='47' width='311' height='16.188'/%3E%3Crect style='fill:%23ffffff;' x='339.812' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23ffffff;' x='45' y='341.812' width='311' height='16.188'/%3E%3Ccircle style='fill:%23ffffff;' cx='348' cy='202' r='44'/%3E%3Cpath style='fill:%23ffffff;' d='M234,286l72,57H234V286Z'/%3E%3Cpath style='fill:%23ffffff;' d='M134,122l72-73H134v73Z'/%3E%3C/svg%3E"
        }
      },
      "home_logo_icon": {
        "disable": false,
        "image_url": {
          "light": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect style='fill:%23033246;' x='45' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23033246;' x='45' y='47' width='311' height='16.188'/%3E%3Crect style='fill:%23033246;' x='339.812' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23033246;' x='45' y='341.812' width='311' height='16.188'/%3E%3Ccircle style='fill:%23033246;' cx='348' cy='202' r='44'/%3E%3Cpath style='fill:%23033246;' d='M234,286l72,57H234V286Z'/%3E%3Cpath style='fill:%23033246;' d='M134,122l72-73H134v73Z'/%3E%3C/svg%3E",
          "dark": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Crect style='fill:%23ffffff;' x='45' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23ffffff;' x='45' y='47' width='311' height='16.188'/%3E%3Crect style='fill:%23ffffff;' x='339.812' y='47' width='16.188' height='311'/%3E%3Crect style='fill:%23ffffff;' x='45' y='341.812' width='311' height='16.188'/%3E%3Ccircle style='fill:%23ffffff;' cx='348' cy='202' r='44'/%3E%3Cpath style='fill:%23ffffff;' d='M234,286l72,57H234V286Z'/%3E%3Cpath style='fill:%23ffffff;' d='M134,122l72-73H134v73Z'/%3E%3C/svg%3E"
        }
      },
      "home_logo_text": {
        "disable": false,
        "image_url": {
          "light": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 677 41'%3E%3Cpath style='fill:%23033246;' d='M0.616,40.2H13.529q7.323-.052,9.239-0.264a10.724,10.724,0,0,0,5.137-1.832,10.285,10.285,0,0,0,3.287-3.981A11.666,11.666,0,0,0,32.4,29a9.426,9.426,0,0,0-1.863-5.827A9.972,9.972,0,0,0,25.2,19.664a8.948,8.948,0,0,0,3.895-3.4,9.128,9.128,0,0,0,1.436-4.983,8.879,8.879,0,0,0-1.165-4.522A9.567,9.567,0,0,0,22.5,1.932a43.043,43.043,0,0,0-6.716-.382H0.616V40.2ZM12.675,7.983q5.408,0,6.547.132a4.362,4.362,0,0,1,2.886,1.358,4.292,4.292,0,0,1,.97,2.914,4.124,4.124,0,0,1-1.126,3.019A5.022,5.022,0,0,1,18.86,16.79q-1.087.132-5.564,0.132H8.276V7.983h4.4Zm1.786,15.372q5.227,0,6.793.554a4.689,4.689,0,0,1,2.394,1.767,5.113,5.113,0,0,1,.828,2.953A4.806,4.806,0,0,1,23.4,31.911a4.723,4.723,0,0,1-2.782,1.542,34.023,34.023,0,0,1-5.253.237H8.276V23.355h6.185ZM47.607,35.6q4.994,5.26,13.457,5.26,8.359,0,13.353-5.287T79.412,20.93q0-9.439-5.033-14.739T60.96,0.89A20.492,20.492,0,0,0,52.782,2.42a14.769,14.769,0,0,0-4.9,3.48,18.214,18.214,0,0,0-3.532,5.3,24.992,24.992,0,0,0-1.734,9.914Q42.612,30.343,47.607,35.6ZM53.4,10.87a9.657,9.657,0,0,1,7.634-3.309,9.593,9.593,0,0,1,7.6,3.27q2.859,3.27,2.86,9.914,0,6.724-2.937,10.086A10.1,10.1,0,0,1,53.481,30.8Q50.5,27.416,50.505,20.85,50.505,14.18,53.4,10.87ZM117.6,40.2V33.691H98.557V1.866H90.9V40.2H117.6Zm18.188,0V1.55h-7.661V40.2h7.661Zm39.02-14.212v4.9a16.452,16.452,0,0,1-4.154,2.333,12.971,12.971,0,0,1-4.826.962,9.938,9.938,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.281,10.281,0,0,1,7.983-3.243,9,9,0,0,1,5.526,1.648,8.193,8.193,0,0,1,3.015,4.5l7.608-1.45a13.669,13.669,0,0,0-5.111-8.345Q172.974,0.891,165.909.89a19.318,19.318,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.594,22.594,0,0,0-2.484,10.731,23.884,23.884,0,0,0,2.225,10.3,16.064,16.064,0,0,0,6.651,7.277,20.454,20.454,0,0,0,10.378,2.544,24.975,24.975,0,0,0,9.251-1.806,20.713,20.713,0,0,0,6.975-4.179v-15.4H166.039v6.513h8.773ZM202.678,40.2V28.523l6.211-6.46L219.318,40.2h9.912l-15.062-23.6L228.454,1.55h-10.3L202.678,18.715V1.55h-7.66V40.2h7.66Zm39.253-4.6q4.995,5.26,13.457,5.26,8.359,0,13.354-5.287t5-14.647q0-9.439-5.034-14.739t-13.418-5.3a20.494,20.494,0,0,0-8.178,1.529,14.769,14.769,0,0,0-4.9,3.48,18.213,18.213,0,0,0-3.532,5.3,24.994,24.994,0,0,0-1.734,9.914Q236.937,30.343,241.931,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.86,9.914,0,6.724-2.938,10.086a10.1,10.1,0,0,1-15.074-.026q-2.976-3.388-2.976-9.954Q244.83,14.18,247.728,10.87ZM292.209,40.2V15L307.5,40.2h7.686V1.55h-7.116V27.363L292.545,1.55h-7.453V40.2h7.117Zm44.092,0V23.777h15.838V17.238H336.3V8.089H354.65V1.55H328.641V40.2h7.66Zm37.39,0V1.55h-7.66V40.2h7.66Zm39.02-14.212v4.9a16.445,16.445,0,0,1-4.153,2.333,12.976,12.976,0,0,1-4.827.962,9.939,9.939,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.285,10.285,0,0,1,7.984-3.243,9,9,0,0,1,5.525,1.648,8.193,8.193,0,0,1,3.015,4.5l7.609-1.45a13.67,13.67,0,0,0-5.112-8.345Q410.874,0.891,403.809.89a19.315,19.315,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.582,22.582,0,0,0-2.485,10.731,23.885,23.885,0,0,0,2.226,10.3,16.058,16.058,0,0,0,6.651,7.277,20.453,20.453,0,0,0,10.377,2.544,24.976,24.976,0,0,0,9.252-1.806,20.7,20.7,0,0,0,6.974-4.179v-15.4H403.938v6.513h8.773Zm20.051-3.823a47.752,47.752,0,0,0,.751,9.809,10.721,10.721,0,0,0,2.148,4.285,11.8,11.8,0,0,0,4.438,3.322,20.661,20.661,0,0,0,8.242,1.279,19.1,19.1,0,0,0,7.3-1.173,11.558,11.558,0,0,0,4.464-3.151,10.968,10.968,0,0,0,2.291-4.852,53.138,53.138,0,0,0,.621-9.835V1.55h-7.66V22.933a44.315,44.315,0,0,1-.337,6.565,5.385,5.385,0,0,1-1.992,3.335,7.618,7.618,0,0,1-4.917,1.358,8.05,8.05,0,0,1-5.06-1.437,6.279,6.279,0,0,1-2.342-3.81,44.238,44.238,0,0,1-.284-6.46V1.55h-7.661V22.169ZM484.075,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.887,5.887,0,0,1,2.3,1.608,54.518,54.518,0,0,1,4.037,5.682l5.538,8.411h9.161l-4.632-7.541a44.094,44.094,0,0,0-4.361-6.275,17.931,17.931,0,0,0-4.1-3.243q4.994-.738,7.5-3.573a10.434,10.434,0,0,0,2.511-7.185A11.3,11.3,0,0,0,505.787,6.3a8.754,8.754,0,0,0-4.412-3.7Q498.62,1.55,492.537,1.55H476.415V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.662,4.662,0,0,1,2.885,1.516,4.69,4.69,0,0,1,1.023,3.151,5.1,5.1,0,0,1-.777,2.9,4.128,4.128,0,0,1-2.148,1.635q-1.371.475-6.883,0.475h-5.668V8.089Zm54.91-6.539h-8.1L516.108,40.2h8.126l3.131-8.78H542.53l3.313,8.78h8.333ZM529.72,24.911l5.124-14.344,5.228,14.344H529.72ZM575.8,40.2V8.089h11.232V1.55H556.888V8.089h11.257V40.2h7.66Zm23.959-4.6q5,5.26,13.457,5.26,8.36,0,13.354-5.287t4.994-14.647q0-9.439-5.033-14.739t-13.418-5.3A20.49,20.49,0,0,0,604.94,2.42a14.769,14.769,0,0,0-4.9,3.48,18.216,18.216,0,0,0-3.533,5.3,25,25,0,0,0-1.733,9.914Q594.77,30.343,599.764,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.859,9.914,0,6.724-2.937,10.086a10.1,10.1,0,0,1-15.074-.026q-2.978-3.388-2.976-9.954Q602.663,14.18,605.561,10.87ZM650.533,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.873,5.873,0,0,1,2.3,1.608,54.36,54.36,0,0,1,4.037,5.682L667.82,40.2h9.162l-4.633-7.541a44.108,44.108,0,0,0-4.36-6.275,17.959,17.959,0,0,0-4.1-3.243q4.994-.738,7.505-3.573a10.438,10.438,0,0,0,2.51-7.185A11.3,11.3,0,0,0,672.246,6.3a8.76,8.76,0,0,0-4.413-3.7Q665.078,1.55,659,1.55H642.873V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.668,4.668,0,0,1,2.886,1.516,4.694,4.694,0,0,1,1.022,3.151,5.108,5.108,0,0,1-.776,2.9,4.136,4.136,0,0,1-2.148,1.635q-1.373.475-6.884,0.475h-5.668V8.089Z'/%3E%3C/svg%3E",
          "dark": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 677 41'%3E%3Cpath style='fill:%23ffffff;' d='M0.616,40.2H13.529q7.323-.052,9.239-0.264a10.724,10.724,0,0,0,5.137-1.832,10.285,10.285,0,0,0,3.287-3.981A11.666,11.666,0,0,0,32.4,29a9.426,9.426,0,0,0-1.863-5.827A9.972,9.972,0,0,0,25.2,19.664a8.948,8.948,0,0,0,3.895-3.4,9.128,9.128,0,0,0,1.436-4.983,8.879,8.879,0,0,0-1.165-4.522A9.567,9.567,0,0,0,22.5,1.932a43.043,43.043,0,0,0-6.716-.382H0.616V40.2ZM12.675,7.983q5.408,0,6.547.132a4.362,4.362,0,0,1,2.886,1.358,4.292,4.292,0,0,1,.97,2.914,4.124,4.124,0,0,1-1.126,3.019A5.022,5.022,0,0,1,18.86,16.79q-1.087.132-5.564,0.132H8.276V7.983h4.4Zm1.786,15.372q5.227,0,6.793.554a4.689,4.689,0,0,1,2.394,1.767,5.113,5.113,0,0,1,.828,2.953A4.806,4.806,0,0,1,23.4,31.911a4.723,4.723,0,0,1-2.782,1.542,34.023,34.023,0,0,1-5.253.237H8.276V23.355h6.185ZM47.607,35.6q4.994,5.26,13.457,5.26,8.359,0,13.353-5.287T79.412,20.93q0-9.439-5.033-14.739T60.96,0.89A20.492,20.492,0,0,0,52.782,2.42a14.769,14.769,0,0,0-4.9,3.48,18.214,18.214,0,0,0-3.532,5.3,24.992,24.992,0,0,0-1.734,9.914Q42.612,30.343,47.607,35.6ZM53.4,10.87a9.657,9.657,0,0,1,7.634-3.309,9.593,9.593,0,0,1,7.6,3.27q2.859,3.27,2.86,9.914,0,6.724-2.937,10.086A10.1,10.1,0,0,1,53.481,30.8Q50.5,27.416,50.505,20.85,50.505,14.18,53.4,10.87ZM117.6,40.2V33.691H98.557V1.866H90.9V40.2H117.6Zm18.188,0V1.55h-7.661V40.2h7.661Zm39.02-14.212v4.9a16.452,16.452,0,0,1-4.154,2.333,12.971,12.971,0,0,1-4.826.962,9.938,9.938,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.281,10.281,0,0,1,7.983-3.243,9,9,0,0,1,5.526,1.648,8.193,8.193,0,0,1,3.015,4.5l7.608-1.45a13.669,13.669,0,0,0-5.111-8.345Q172.974,0.891,165.909.89a19.318,19.318,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.594,22.594,0,0,0-2.484,10.731,23.884,23.884,0,0,0,2.225,10.3,16.064,16.064,0,0,0,6.651,7.277,20.454,20.454,0,0,0,10.378,2.544,24.975,24.975,0,0,0,9.251-1.806,20.713,20.713,0,0,0,6.975-4.179v-15.4H166.039v6.513h8.773ZM202.678,40.2V28.523l6.211-6.46L219.318,40.2h9.912l-15.062-23.6L228.454,1.55h-10.3L202.678,18.715V1.55h-7.66V40.2h7.66Zm39.253-4.6q4.995,5.26,13.457,5.26,8.359,0,13.354-5.287t5-14.647q0-9.439-5.034-14.739t-13.418-5.3a20.494,20.494,0,0,0-8.178,1.529,14.769,14.769,0,0,0-4.9,3.48,18.213,18.213,0,0,0-3.532,5.3,24.994,24.994,0,0,0-1.734,9.914Q236.937,30.343,241.931,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.86,9.914,0,6.724-2.938,10.086a10.1,10.1,0,0,1-15.074-.026q-2.976-3.388-2.976-9.954Q244.83,14.18,247.728,10.87ZM292.209,40.2V15L307.5,40.2h7.686V1.55h-7.116V27.363L292.545,1.55h-7.453V40.2h7.117Zm44.092,0V23.777h15.838V17.238H336.3V8.089H354.65V1.55H328.641V40.2h7.66Zm37.39,0V1.55h-7.66V40.2h7.66Zm39.02-14.212v4.9a16.445,16.445,0,0,1-4.153,2.333,12.976,12.976,0,0,1-4.827.962,9.939,9.939,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.285,10.285,0,0,1,7.984-3.243,9,9,0,0,1,5.525,1.648,8.193,8.193,0,0,1,3.015,4.5l7.609-1.45a13.67,13.67,0,0,0-5.112-8.345Q410.874,0.891,403.809.89a19.315,19.315,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.582,22.582,0,0,0-2.485,10.731,23.885,23.885,0,0,0,2.226,10.3,16.058,16.058,0,0,0,6.651,7.277,20.453,20.453,0,0,0,10.377,2.544,24.976,24.976,0,0,0,9.252-1.806,20.7,20.7,0,0,0,6.974-4.179v-15.4H403.938v6.513h8.773Zm20.051-3.823a47.752,47.752,0,0,0,.751,9.809,10.721,10.721,0,0,0,2.148,4.285,11.8,11.8,0,0,0,4.438,3.322,20.661,20.661,0,0,0,8.242,1.279,19.1,19.1,0,0,0,7.3-1.173,11.558,11.558,0,0,0,4.464-3.151,10.968,10.968,0,0,0,2.291-4.852,53.138,53.138,0,0,0,.621-9.835V1.55h-7.66V22.933a44.315,44.315,0,0,1-.337,6.565,5.385,5.385,0,0,1-1.992,3.335,7.618,7.618,0,0,1-4.917,1.358,8.05,8.05,0,0,1-5.06-1.437,6.279,6.279,0,0,1-2.342-3.81,44.238,44.238,0,0,1-.284-6.46V1.55h-7.661V22.169ZM484.075,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.887,5.887,0,0,1,2.3,1.608,54.518,54.518,0,0,1,4.037,5.682l5.538,8.411h9.161l-4.632-7.541a44.094,44.094,0,0,0-4.361-6.275,17.931,17.931,0,0,0-4.1-3.243q4.994-.738,7.5-3.573a10.434,10.434,0,0,0,2.511-7.185A11.3,11.3,0,0,0,505.787,6.3a8.754,8.754,0,0,0-4.412-3.7Q498.62,1.55,492.537,1.55H476.415V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.662,4.662,0,0,1,2.885,1.516,4.69,4.69,0,0,1,1.023,3.151,5.1,5.1,0,0,1-.777,2.9,4.128,4.128,0,0,1-2.148,1.635q-1.371.475-6.883,0.475h-5.668V8.089Zm54.91-6.539h-8.1L516.108,40.2h8.126l3.131-8.78H542.53l3.313,8.78h8.333ZM529.72,24.911l5.124-14.344,5.228,14.344H529.72ZM575.8,40.2V8.089h11.232V1.55H556.888V8.089h11.257V40.2h7.66Zm23.959-4.6q5,5.26,13.457,5.26,8.36,0,13.354-5.287t4.994-14.647q0-9.439-5.033-14.739t-13.418-5.3A20.49,20.49,0,0,0,604.94,2.42a14.769,14.769,0,0,0-4.9,3.48,18.216,18.216,0,0,0-3.533,5.3,25,25,0,0,0-1.733,9.914Q594.77,30.343,599.764,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.859,9.914,0,6.724-2.937,10.086a10.1,10.1,0,0,1-15.074-.026q-2.978-3.388-2.976-9.954Q602.663,14.18,605.561,10.87ZM650.533,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.873,5.873,0,0,1,2.3,1.608,54.36,54.36,0,0,1,4.037,5.682L667.82,40.2h9.162l-4.633-7.541a44.108,44.108,0,0,0-4.36-6.275,17.959,17.959,0,0,0-4.1-3.243q4.994-.738,7.505-3.573a10.438,10.438,0,0,0,2.51-7.185A11.3,11.3,0,0,0,672.246,6.3a8.76,8.76,0,0,0-4.413-3.7Q665.078,1.55,659,1.55H642.873V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.668,4.668,0,0,1,2.886,1.516,4.694,4.694,0,0,1,1.022,3.151,5.108,5.108,0,0,1-.776,2.9,4.136,4.136,0,0,1-2.148,1.635q-1.373.475-6.884,0.475h-5.668V8.089Z'/%3E%3C/svg%3E"
        }
      },
      "footer_logo": {
        "disable": false,
        "image_url": {
          "light": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 677 41'%3E%3Cpath style='fill:%23033246;' d='M0.616,40.2H13.529q7.323-.052,9.239-0.264a10.724,10.724,0,0,0,5.137-1.832,10.285,10.285,0,0,0,3.287-3.981A11.666,11.666,0,0,0,32.4,29a9.426,9.426,0,0,0-1.863-5.827A9.972,9.972,0,0,0,25.2,19.664a8.948,8.948,0,0,0,3.895-3.4,9.128,9.128,0,0,0,1.436-4.983,8.879,8.879,0,0,0-1.165-4.522A9.567,9.567,0,0,0,22.5,1.932a43.043,43.043,0,0,0-6.716-.382H0.616V40.2ZM12.675,7.983q5.408,0,6.547.132a4.362,4.362,0,0,1,2.886,1.358,4.292,4.292,0,0,1,.97,2.914,4.124,4.124,0,0,1-1.126,3.019A5.022,5.022,0,0,1,18.86,16.79q-1.087.132-5.564,0.132H8.276V7.983h4.4Zm1.786,15.372q5.227,0,6.793.554a4.689,4.689,0,0,1,2.394,1.767,5.113,5.113,0,0,1,.828,2.953A4.806,4.806,0,0,1,23.4,31.911a4.723,4.723,0,0,1-2.782,1.542,34.023,34.023,0,0,1-5.253.237H8.276V23.355h6.185ZM47.607,35.6q4.994,5.26,13.457,5.26,8.359,0,13.353-5.287T79.412,20.93q0-9.439-5.033-14.739T60.96,0.89A20.492,20.492,0,0,0,52.782,2.42a14.769,14.769,0,0,0-4.9,3.48,18.214,18.214,0,0,0-3.532,5.3,24.992,24.992,0,0,0-1.734,9.914Q42.612,30.343,47.607,35.6ZM53.4,10.87a9.657,9.657,0,0,1,7.634-3.309,9.593,9.593,0,0,1,7.6,3.27q2.859,3.27,2.86,9.914,0,6.724-2.937,10.086A10.1,10.1,0,0,1,53.481,30.8Q50.5,27.416,50.505,20.85,50.505,14.18,53.4,10.87ZM117.6,40.2V33.691H98.557V1.866H90.9V40.2H117.6Zm18.188,0V1.55h-7.661V40.2h7.661Zm39.02-14.212v4.9a16.452,16.452,0,0,1-4.154,2.333,12.971,12.971,0,0,1-4.826.962,9.938,9.938,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.281,10.281,0,0,1,7.983-3.243,9,9,0,0,1,5.526,1.648,8.193,8.193,0,0,1,3.015,4.5l7.608-1.45a13.669,13.669,0,0,0-5.111-8.345Q172.974,0.891,165.909.89a19.318,19.318,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.594,22.594,0,0,0-2.484,10.731,23.884,23.884,0,0,0,2.225,10.3,16.064,16.064,0,0,0,6.651,7.277,20.454,20.454,0,0,0,10.378,2.544,24.975,24.975,0,0,0,9.251-1.806,20.713,20.713,0,0,0,6.975-4.179v-15.4H166.039v6.513h8.773ZM202.678,40.2V28.523l6.211-6.46L219.318,40.2h9.912l-15.062-23.6L228.454,1.55h-10.3L202.678,18.715V1.55h-7.66V40.2h7.66Zm39.253-4.6q4.995,5.26,13.457,5.26,8.359,0,13.354-5.287t5-14.647q0-9.439-5.034-14.739t-13.418-5.3a20.494,20.494,0,0,0-8.178,1.529,14.769,14.769,0,0,0-4.9,3.48,18.213,18.213,0,0,0-3.532,5.3,24.994,24.994,0,0,0-1.734,9.914Q236.937,30.343,241.931,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.86,9.914,0,6.724-2.938,10.086a10.1,10.1,0,0,1-15.074-.026q-2.976-3.388-2.976-9.954Q244.83,14.18,247.728,10.87ZM292.209,40.2V15L307.5,40.2h7.686V1.55h-7.116V27.363L292.545,1.55h-7.453V40.2h7.117Zm44.092,0V23.777h15.838V17.238H336.3V8.089H354.65V1.55H328.641V40.2h7.66Zm37.39,0V1.55h-7.66V40.2h7.66Zm39.02-14.212v4.9a16.445,16.445,0,0,1-4.153,2.333,12.976,12.976,0,0,1-4.827.962,9.939,9.939,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.285,10.285,0,0,1,7.984-3.243,9,9,0,0,1,5.525,1.648,8.193,8.193,0,0,1,3.015,4.5l7.609-1.45a13.67,13.67,0,0,0-5.112-8.345Q410.874,0.891,403.809.89a19.315,19.315,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.582,22.582,0,0,0-2.485,10.731,23.885,23.885,0,0,0,2.226,10.3,16.058,16.058,0,0,0,6.651,7.277,20.453,20.453,0,0,0,10.377,2.544,24.976,24.976,0,0,0,9.252-1.806,20.7,20.7,0,0,0,6.974-4.179v-15.4H403.938v6.513h8.773Zm20.051-3.823a47.752,47.752,0,0,0,.751,9.809,10.721,10.721,0,0,0,2.148,4.285,11.8,11.8,0,0,0,4.438,3.322,20.661,20.661,0,0,0,8.242,1.279,19.1,19.1,0,0,0,7.3-1.173,11.558,11.558,0,0,0,4.464-3.151,10.968,10.968,0,0,0,2.291-4.852,53.138,53.138,0,0,0,.621-9.835V1.55h-7.66V22.933a44.315,44.315,0,0,1-.337,6.565,5.385,5.385,0,0,1-1.992,3.335,7.618,7.618,0,0,1-4.917,1.358,8.05,8.05,0,0,1-5.06-1.437,6.279,6.279,0,0,1-2.342-3.81,44.238,44.238,0,0,1-.284-6.46V1.55h-7.661V22.169ZM484.075,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.887,5.887,0,0,1,2.3,1.608,54.518,54.518,0,0,1,4.037,5.682l5.538,8.411h9.161l-4.632-7.541a44.094,44.094,0,0,0-4.361-6.275,17.931,17.931,0,0,0-4.1-3.243q4.994-.738,7.5-3.573a10.434,10.434,0,0,0,2.511-7.185A11.3,11.3,0,0,0,505.787,6.3a8.754,8.754,0,0,0-4.412-3.7Q498.62,1.55,492.537,1.55H476.415V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.662,4.662,0,0,1,2.885,1.516,4.69,4.69,0,0,1,1.023,3.151,5.1,5.1,0,0,1-.777,2.9,4.128,4.128,0,0,1-2.148,1.635q-1.371.475-6.883,0.475h-5.668V8.089Zm54.91-6.539h-8.1L516.108,40.2h8.126l3.131-8.78H542.53l3.313,8.78h8.333ZM529.72,24.911l5.124-14.344,5.228,14.344H529.72ZM575.8,40.2V8.089h11.232V1.55H556.888V8.089h11.257V40.2h7.66Zm23.959-4.6q5,5.26,13.457,5.26,8.36,0,13.354-5.287t4.994-14.647q0-9.439-5.033-14.739t-13.418-5.3A20.49,20.49,0,0,0,604.94,2.42a14.769,14.769,0,0,0-4.9,3.48,18.216,18.216,0,0,0-3.533,5.3,25,25,0,0,0-1.733,9.914Q594.77,30.343,599.764,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.859,9.914,0,6.724-2.937,10.086a10.1,10.1,0,0,1-15.074-.026q-2.978-3.388-2.976-9.954Q602.663,14.18,605.561,10.87ZM650.533,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.873,5.873,0,0,1,2.3,1.608,54.36,54.36,0,0,1,4.037,5.682L667.82,40.2h9.162l-4.633-7.541a44.108,44.108,0,0,0-4.36-6.275,17.959,17.959,0,0,0-4.1-3.243q4.994-.738,7.505-3.573a10.438,10.438,0,0,0,2.51-7.185A11.3,11.3,0,0,0,672.246,6.3a8.76,8.76,0,0,0-4.413-3.7Q665.078,1.55,659,1.55H642.873V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.668,4.668,0,0,1,2.886,1.516,4.694,4.694,0,0,1,1.022,3.151,5.108,5.108,0,0,1-.776,2.9,4.136,4.136,0,0,1-2.148,1.635q-1.373.475-6.884,0.475h-5.668V8.089Z'/%3E%3C/svg%3E",
          "dark": "data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 677 41'%3E%3Cpath style='fill:%23ffffff;' d='M0.616,40.2H13.529q7.323-.052,9.239-0.264a10.724,10.724,0,0,0,5.137-1.832,10.285,10.285,0,0,0,3.287-3.981A11.666,11.666,0,0,0,32.4,29a9.426,9.426,0,0,0-1.863-5.827A9.972,9.972,0,0,0,25.2,19.664a8.948,8.948,0,0,0,3.895-3.4,9.128,9.128,0,0,0,1.436-4.983,8.879,8.879,0,0,0-1.165-4.522A9.567,9.567,0,0,0,22.5,1.932a43.043,43.043,0,0,0-6.716-.382H0.616V40.2ZM12.675,7.983q5.408,0,6.547.132a4.362,4.362,0,0,1,2.886,1.358,4.292,4.292,0,0,1,.97,2.914,4.124,4.124,0,0,1-1.126,3.019A5.022,5.022,0,0,1,18.86,16.79q-1.087.132-5.564,0.132H8.276V7.983h4.4Zm1.786,15.372q5.227,0,6.793.554a4.689,4.689,0,0,1,2.394,1.767,5.113,5.113,0,0,1,.828,2.953A4.806,4.806,0,0,1,23.4,31.911a4.723,4.723,0,0,1-2.782,1.542,34.023,34.023,0,0,1-5.253.237H8.276V23.355h6.185ZM47.607,35.6q4.994,5.26,13.457,5.26,8.359,0,13.353-5.287T79.412,20.93q0-9.439-5.033-14.739T60.96,0.89A20.492,20.492,0,0,0,52.782,2.42a14.769,14.769,0,0,0-4.9,3.48,18.214,18.214,0,0,0-3.532,5.3,24.992,24.992,0,0,0-1.734,9.914Q42.612,30.343,47.607,35.6ZM53.4,10.87a9.657,9.657,0,0,1,7.634-3.309,9.593,9.593,0,0,1,7.6,3.27q2.859,3.27,2.86,9.914,0,6.724-2.937,10.086A10.1,10.1,0,0,1,53.481,30.8Q50.5,27.416,50.505,20.85,50.505,14.18,53.4,10.87ZM117.6,40.2V33.691H98.557V1.866H90.9V40.2H117.6Zm18.188,0V1.55h-7.661V40.2h7.661Zm39.02-14.212v4.9a16.452,16.452,0,0,1-4.154,2.333,12.971,12.971,0,0,1-4.826.962,9.938,9.938,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.281,10.281,0,0,1,7.983-3.243,9,9,0,0,1,5.526,1.648,8.193,8.193,0,0,1,3.015,4.5l7.608-1.45a13.669,13.669,0,0,0-5.111-8.345Q172.974,0.891,165.909.89a19.318,19.318,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.594,22.594,0,0,0-2.484,10.731,23.884,23.884,0,0,0,2.225,10.3,16.064,16.064,0,0,0,6.651,7.277,20.454,20.454,0,0,0,10.378,2.544,24.975,24.975,0,0,0,9.251-1.806,20.713,20.713,0,0,0,6.975-4.179v-15.4H166.039v6.513h8.773ZM202.678,40.2V28.523l6.211-6.46L219.318,40.2h9.912l-15.062-23.6L228.454,1.55h-10.3L202.678,18.715V1.55h-7.66V40.2h7.66Zm39.253-4.6q4.995,5.26,13.457,5.26,8.359,0,13.354-5.287t5-14.647q0-9.439-5.034-14.739t-13.418-5.3a20.494,20.494,0,0,0-8.178,1.529,14.769,14.769,0,0,0-4.9,3.48,18.213,18.213,0,0,0-3.532,5.3,24.994,24.994,0,0,0-1.734,9.914Q236.937,30.343,241.931,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.86,9.914,0,6.724-2.938,10.086a10.1,10.1,0,0,1-15.074-.026q-2.976-3.388-2.976-9.954Q244.83,14.18,247.728,10.87ZM292.209,40.2V15L307.5,40.2h7.686V1.55h-7.116V27.363L292.545,1.55h-7.453V40.2h7.117Zm44.092,0V23.777h15.838V17.238H336.3V8.089H354.65V1.55H328.641V40.2h7.66Zm37.39,0V1.55h-7.66V40.2h7.66Zm39.02-14.212v4.9a16.445,16.445,0,0,1-4.153,2.333,12.976,12.976,0,0,1-4.827.962,9.939,9.939,0,0,1-7.867-3.441q-3-3.441-3-10.323,0-6.381,2.963-9.624a10.285,10.285,0,0,1,7.984-3.243,9,9,0,0,1,5.525,1.648,8.193,8.193,0,0,1,3.015,4.5l7.609-1.45a13.67,13.67,0,0,0-5.112-8.345Q410.874,0.891,403.809.89a19.315,19.315,0,0,0-9.083,1.925,16.881,16.881,0,0,0-7.272,7.2,22.582,22.582,0,0,0-2.485,10.731,23.885,23.885,0,0,0,2.226,10.3,16.058,16.058,0,0,0,6.651,7.277,20.453,20.453,0,0,0,10.377,2.544,24.976,24.976,0,0,0,9.252-1.806,20.7,20.7,0,0,0,6.974-4.179v-15.4H403.938v6.513h8.773Zm20.051-3.823a47.752,47.752,0,0,0,.751,9.809,10.721,10.721,0,0,0,2.148,4.285,11.8,11.8,0,0,0,4.438,3.322,20.661,20.661,0,0,0,8.242,1.279,19.1,19.1,0,0,0,7.3-1.173,11.558,11.558,0,0,0,4.464-3.151,10.968,10.968,0,0,0,2.291-4.852,53.138,53.138,0,0,0,.621-9.835V1.55h-7.66V22.933a44.315,44.315,0,0,1-.337,6.565,5.385,5.385,0,0,1-1.992,3.335,7.618,7.618,0,0,1-4.917,1.358,8.05,8.05,0,0,1-5.06-1.437,6.279,6.279,0,0,1-2.342-3.81,44.238,44.238,0,0,1-.284-6.46V1.55h-7.661V22.169ZM484.075,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.887,5.887,0,0,1,2.3,1.608,54.518,54.518,0,0,1,4.037,5.682l5.538,8.411h9.161l-4.632-7.541a44.094,44.094,0,0,0-4.361-6.275,17.931,17.931,0,0,0-4.1-3.243q4.994-.738,7.5-3.573a10.434,10.434,0,0,0,2.511-7.185A11.3,11.3,0,0,0,505.787,6.3a8.754,8.754,0,0,0-4.412-3.7Q498.62,1.55,492.537,1.55H476.415V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.662,4.662,0,0,1,2.885,1.516,4.69,4.69,0,0,1,1.023,3.151,5.1,5.1,0,0,1-.777,2.9,4.128,4.128,0,0,1-2.148,1.635q-1.371.475-6.883,0.475h-5.668V8.089Zm54.91-6.539h-8.1L516.108,40.2h8.126l3.131-8.78H542.53l3.313,8.78h8.333ZM529.72,24.911l5.124-14.344,5.228,14.344H529.72ZM575.8,40.2V8.089h11.232V1.55H556.888V8.089h11.257V40.2h7.66Zm23.959-4.6q5,5.26,13.457,5.26,8.36,0,13.354-5.287t4.994-14.647q0-9.439-5.033-14.739t-13.418-5.3A20.49,20.49,0,0,0,604.94,2.42a14.769,14.769,0,0,0-4.9,3.48,18.216,18.216,0,0,0-3.533,5.3,25,25,0,0,0-1.733,9.914Q594.77,30.343,599.764,35.6Zm5.8-24.732a10.459,10.459,0,0,1,15.23-.04q2.859,3.27,2.859,9.914,0,6.724-2.937,10.086a10.1,10.1,0,0,1-15.074-.026q-2.978-3.388-2.976-9.954Q602.663,14.18,605.561,10.87ZM650.533,40.2V24.067h1.553a12.406,12.406,0,0,1,3.856.435,5.873,5.873,0,0,1,2.3,1.608,54.36,54.36,0,0,1,4.037,5.682L667.82,40.2h9.162l-4.633-7.541a44.108,44.108,0,0,0-4.36-6.275,17.959,17.959,0,0,0-4.1-3.243q4.994-.738,7.505-3.573a10.438,10.438,0,0,0,2.51-7.185A11.3,11.3,0,0,0,672.246,6.3a8.76,8.76,0,0,0-4.413-3.7Q665.078,1.55,659,1.55H642.873V40.2h7.66Zm0-32.115h5.978q4.659,0,5.59.132a4.668,4.668,0,0,1,2.886,1.516,4.694,4.694,0,0,1,1.022,3.151,5.108,5.108,0,0,1-.776,2.9,4.136,4.136,0,0,1-2.148,1.635q-1.373.475-6.884,0.475h-5.668V8.089Z'/%3E%3C/svg%3E"
        }
      },
      "footer_copyright": {
        "lang_1": "SA Development 1. © 2022",
        "lang_2": "SA Development 1. © 2022"
      },
      "languages": ["lang_1", "lang_2"],
      "currency": {
        "lang_1": "HUF",
        "lang_2": "EUR"
      },
      "currency_value": {
        "lang_1": 1,
        "lang_2": 0.0028
      }
    },
    "project_settings": {
      "project_address": {
        "lang_1": "1010 Budapest, Utca utca 7.",
        "lang_2": "Budapest H-1010, Utca street 7."
      },
      "project_contact_person": {
        "lang_1": "Lantos Imola",
        "lang_2": "Imola Lantos"
      },
      "project_contact_phone": {
        "lang_1": "36301324567",
        "lang_2": "36301324567"
      },
      "project_contact_email": {
        "lang_1": "imola.lantos@studioarkitekter.com",
        "lang_2": "imola.lantos@studioarkitekter.com"
      },
      "gallery": [{
        "image_url": "https://configurator.studioarkitekter.com/demo/project_gallery_0.jpg"
      }, {
        "image_url": "https://configurator.studioarkitekter.com/demo/project_gallery_1.jpg"
      }]
    },
    "models_settings": {
      "models_name": {
        "lang_1": "Válassza ki a lakás stílusát",
        "lang_2": "Choose the model of the apartment"
      },
      "models_description": {
        "lang_1": "Stílusok leírása, , lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "lang_2": "Description of styles, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      }
    },
    "configurations_settings": {
      "configurations_name": {
        "lang_1": "Válassza ki a lakás tulajdonságainak kezdő összeállítását",
        "lang_2": "Select the start collection of the apartment properties"
      },
      "configurations_description": {
        "lang_1": "Összeállításokról általában, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "lang_2": "Collections description, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      }
    },
    "summary_settings": {
      "summary_name": {
        "lang_1": "Jó választás! Íme a lakásod adatai",
        "lang_2": "Good choice! Here is the details of your apartment"
      },
      "summary_description": {
        "lang_1": "Összegzés oldal szöveg, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "lang_2": "Summary page description, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      },
      "summary_founding_name": {
        "lang_1": "Finanszírozási lehetőségek",
        "lang_2": "Funding opportunities"
      },
      "summary_founding_description": {
        "lang_1": "Finanszírozási lehetőségek leírása, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        "lang_2": "Funding opportunities description, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      },
      "summary_contact_name": {
        "lang_1": "Kapcsolatfelvétel",
        "lang_2": "Contact us"
      },
      "summary_save_options_name": {
        "lang_1": "Mentés",
        "lang_2": "Save"
      }
    },
    "context": {
      "menus": {
        "startConfiguratorMenu": {
          "lang_1": "Konfigurátor indítása",
          "lang_2": "Start configurator"
        },
        "descriptionMenu": {
          "lang_1": "Leírás",
          "lang_2": "Description"
        },
        "modelsMenu": {
          "lang_1": "Stílus",
          "lang_2": "Style"
        },
        "collectionsMenu": {
          "lang_1": "Összeállítás",
          "lang_2": "Collection"
        },
        "summaryMenu": {
          "lang_1": "Összegzés",
          "lang_2": "Summary"
        },
        "collectionsMenuCustomSpan": {
          "lang_1": "Egyedi",
          "lang_2": "Custom"
        }
      },
      "messages": {
        "notFoundModel": {
          "lang_1": "Nincsenek stílusok ebben a konfigurátorban",
          "lang_2": "There are not styles in this configurator"
        },
        "notFoundCollection": {
          "lang_1": "Nincsenek összeállítások ehhez a stílushoz",
          "lang_2": "There are not collections for this style"
        },
        "notFoundAnswer": {
          "lang_1": "Nincsenek opciók ehhez a kérdéshez",
          "lang_2": "There are not options for this question"
        }
      },
      "labels": {
        "nextLabel": {
          "lang_1": "Következő",
          "lang_2": "Next"
        },
        "prevLabel": {
          "lang_1": "Előző",
          "lang_2": "Prev"
        },
        "summaryLabel": {
          "lang_1": "Összegzés",
          "lang_2": "Summary"
        },
        "modelsLabel": {
          "lang_1": "Stílusok",
          "lang_2": "Styles"
        },
        "collectionsLabel": {
          "lang_1": "Összeállítások",
          "lang_2": "Collections"
        },
        "copyUrlToClipboardLabel": {
          "lang_1": "Url másolása a vágólapra",
          "lang_2": "Copy url to clipboard"
        },
        "printLabel": {
          "lang_1": "Nyomtatás",
          "lang_2": "Print"
        },
        "selectLabel": {
          "lang_1": "Kiválasztás",
          "lang_2": "Select"
        },
        "selectedLabel": {
          "lang_1": "Kiválasztva",
          "lang_2": "Selected"
        },
        "languages": {
          "lang_1": "Magyar",
          "lang_2": "English"
        }
      }
    }
  },
  "models": [{
    "key": "minimal",
    "name": {
      "lang_1": "Minimal",
      "lang_2": "Minimal"
    },
    "description": {
      "lang_1": "Minimal stílus, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
      "lang_2": "Minimal design, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
    },
    "content": {
      "lang_1": "Hosszú szöveg lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      "lang_2": "Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },
    "price": {
      "lang_1": 69000000
    },
    "gallery": [{
      "image_url": "https://configurator.studioarkitekter.com/demo/minimal_gallery_0.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/minimal_gallery_1.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/minimal_gallery_2.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/floorplan.jpg"
    }],
    "gallery_index_for_summary": 3,
    "collections": [{
      "key": "basic",
      "name": {
        "lang_1": " Basic",
        "lang_2": "Basic"
      },
      "description": {
        "lang_1": "Ez az alapcsomag, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
        "lang_2": "This is the basic package, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
      }
    }, {
      "key": "firstHome",
      "name": {
        "lang_1": "First home",
        "lang_2": "First home"
      },
      "description": {
        "lang_1": "Ez a közepes összeállítás, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
        "lang_2": "This is the medium collection, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
      }
    }, {
      "key": "dreamHome",
      "name": {
        "lang_1": "Dream home",
        "lang_2": "Dream home"
      },
      "description": {
        "lang_1": "Ez a prémium összeállítás, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
        "lang_2": "This is the premium selection, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
      }
    }],
    "steps": [{
      "key": "technical-equipment",
      "name": {
        "lang_1": "Műszaki felszereltség",
        "lang_2": "Technical equipment"
      },
      "description": {
        "lang_1": "Válassza ki a lakása műszaki felszereltségét",
        "lang_2": "Choose the technical equipment of your apartment"
      },
      "options": [{
        "key": "heating-system",
        "name": {
          "lang_1": "Fűtésmeghajtás",
          "lang_2": "Heating system"
        },
        "description": {
          "lang_1": "Válassza ki milyen fűtésrendszert szeretne",
          "lang_2": "Choose the type of the heating system"
        },
        "options": [{
          "key": "electronic",
          "name": {
            "lang_1": "Elektromos",
            "lang_2": "Electronic"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "gallery": [],
          "layer": []
        }, {
          "key": "gas",
          "name": {
            "lang_1": "Gázos",
            "lang_2": "Gas"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 850000
          },
          "collections": ["firstHome"],
          "gallery": [],
          "layer": []
        }, {
          "key": "heat-pump",
          "name": {
            "lang_1": "Hőszivattyús",
            "lang_2": "Heat pump"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 2850000
          },
          "collections": ["dreamHome"],
          "gallery": [],
          "layer": []
        }]
      }, {
        "key": "heating-surface",
        "name": {
          "lang_1": "Fűtőfelület",
          "lang_2": "Heating surface"
        },
        "description": {
          "lang_1": "\"Válassza ki milyen fűtőfelületet szeretne",
          "lang_2": "Choose the type of the heating surface"
        },
        "options": [{
          "key": "radiator",
          "name": {
            "lang_1": "Radiátor",
            "lang_2": "Radiator"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "gallery": [],
          "layer": []
        }, {
          "key": "floor",
          "name": {
            "lang_1": "Padló",
            "lang_2": "Floor"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 1750000
          },
          "collections": ["firstHome"],
          "gallery": [],
          "layer": []
        }, {
          "key": "floor-wall",
          "name": {
            "lang_1": "Padló-fal",
            "lang_2": "Floor-wall"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 3525000
          },
          "collections": [],
          "gallery": [],
          "layer": []
        }, {
          "key": "floor-ceiling",
          "name": {
            "lang_1": "Padló-mennyezet",
            "lang_2": "Floor-ceiling"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 3525000
          },
          "collections": ["dreamHome"],
          "gallery": [],
          "layer": []
        }]
      }, {
        "key": "cooling",
        "name": {
          "lang_1": "Hűtés",
          "lang_2": "Cooling"
        },
        "description": {
          "lang_1": "Válassza ki milyen hűtőrendszert szeretne",
          "lang_2": "Choose the type of the cooling system"
        },
        "options": [{
          "key": "air-conditioner",
          "name": {
            "lang_1": "Klima",
            "lang_2": "Air conditioner"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic", "firstHome"],
          "gallery": [],
          "layer": []
        }, {
          "key": "surface-cooling",
          "name": {
            "lang_1": "Felülethűtés",
            "lang_2": "Surface cooling"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 2550000
          },
          "collections": ["dreamHome"],
          "gallery": [],
          "layer": []
        }]
      }, {
        "key": "electronic-system",
        "name": {
          "lang_1": "Villamos rendszer",
          "lang_2": "Electronic system"
        },
        "description": {
          "lang_1": "Válassza ki milyen elektromos rendszert szeretne",
          "lang_2": "Choose the type of the electronic system"
        },
        "options": [{
          "key": "not-smart",
          "name": {
            "lang_1": "Nem okos",
            "lang_2": "Not smart"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "gallery": [],
          "layer": []
        }, {
          "key": "smart-kameleon",
          "name": {
            "lang_1": "Okos - Kameleon",
            "lang_2": "Smart - Kameleon"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 2550000
          },
          "collections": ["firstHome"],
          "gallery": [],
          "layer": []
        }, {
          "key": "smart-loxone",
          "name": {
            "lang_1": "Okos - Loxone",
            "lang_2": "Smart - Loxone"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 5100000
          },
          "collections": ["dreamHome"],
          "gallery": [],
          "layer": []
        }]
      }],
      "layer": []
    }, {
      "key": "kitchen",
      "name": {
        "lang_1": "Konyha",
        "lang_2": "Kitchen"
      },
      "description": {
        "lang_1": "Válassza ki a konyhája felszereltségét és kinézetét",
        "lang_2": "Choose the technical equipment and design of your kitchen"
      },
      "layer": [{
        "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen.jpg",
        "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen.jpg?night"
      }, {
        "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen.jpg",
        "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen.jpg?night"
      }],
      "options": [{
        "key": "pavement",
        "name": {
          "lang_1": "Burkolat",
          "lang_2": "Pavement"
        },
        "description": {
          "lang_1": "Válassza ki a konyhája burkolatát",
          "lang_2": "Choose the pavement of your kitchen"
        },
        "options": [{
          "key": "pvc-laminate",
          "name": {
            "lang_1": "PVC - laminált",
            "lang_2": "PVC - laminate"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_0.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_0.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_0.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_0.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_green.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "carpet",
          "name": {
            "lang_1": "Padlószőnyeg",
            "lang_2": "Carpet"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 150000
          },
          "collections": [],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_1.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_1.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_1.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_1.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_pink.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "tile",
          "name": {
            "lang_1": "Hidegburkolat",
            "lang_2": "Tile"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 600000
          },
          "collections": ["firstHome"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_2.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_2.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_2.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_2.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_orange.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "floor",
          "name": {
            "lang_1": "Parketta",
            "lang_2": "Floor"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 1200000
          },
          "collections": ["dreamHome"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_3.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_3.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_3.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_pavement_3.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_blue.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }]
      }, {
        "key": "furniture-color",
        "name": {
          "lang_1": "Bútorszín",
          "lang_2": "Furniture color"
        },
        "description": {
          "lang_1": "Válassza ki a konyhabútora színét",
          "lang_2": "Choose the color of your kitchen furniture"
        },
        "options": [{
          "key": "laminate",
          "name": {
            "lang_1": "Laminált",
            "lang_2": "Laminate"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_0.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_0.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_0.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_0.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_green.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "veneered-front",
          "name": {
            "lang_1": "Furnéros front",
            "lang_2": "Veneered front"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": [],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_1.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_1.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_1.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_1.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_pink.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "painted-matt",
          "name": {
            "lang_1": "Festett matt",
            "lang_2": "Painted matt"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 350000
          },
          "collections": ["firstHome"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_2.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_2.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_2.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_2.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_orange.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "painted-brightly",
          "name": {
            "lang_1": "Festett fényes",
            "lang_2": "Painted brightly"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 450000
          },
          "collections": [],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_3.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_3.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_3.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_3.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_blue.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "glass",
          "name": {
            "lang_1": "Üveg",
            "lang_2": "Glass"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 650000
          },
          "collections": ["dreamHome"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_4.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_4.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_4.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_4.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_yellow.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "stone",
          "name": {
            "lang_1": "Kő",
            "lang_2": "Stone"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 950000
          },
          "collections": [],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_5.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_5.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_5.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_furniture_color_5.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_red.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }]
      }, {
        "key": "worktop",
        "name": {
          "lang_1": "Munkalap",
          "lang_2": "Worktop"
        },
        "description": {
          "lang_1": "Válassza ki a konyhája munkalapját",
          "lang_2": "Choose the tyoe of your kitchen worktop"
        },
        "options": [{
          "key": "laminate",
          "name": {
            "lang_1": "Laminált",
            "lang_2": "Laminate"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_0.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_0.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_0.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_0.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_green.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "artifical-stone",
          "name": {
            "lang_1": "Műkő",
            "lang_2": "Artificial stone"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 300000
          },
          "collections": ["firstHome"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_1.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_1.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_1.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_1.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_pink.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }, {
          "key": "marble",
          "name": {
            "lang_1": "Márvány",
            "lang_2": "Marble"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 600000
          },
          "collections": ["dreamHome"],
          "layer": [{
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_2.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_2.png?night"
          }, {
            "image_url_day": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_2.png",
            "image_url_night": "https://configurator.studioarkitekter.com/demo/minimal_kitchen_worktop_2.png?night"
          }],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_orange.jpg"
          }, {
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }]
        }]
      }, {
        "key": "sink-tray",
        "name": {
          "lang_1": "Mosogató tálca",
          "lang_2": "Sink tray"
        },
        "description": {
          "lang_1": "Válassza ki a mosogató tálca típusát",
          "lang_2": "Choose the type of your sink tray"
        },
        "options": [{
          "key": "worktop-material",
          "name": {
            "lang_1": "Pult anyaga",
            "lang_2": "Worktop material"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic"],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }],
          "layer": []
        }, {
          "key": "individually-designed",
          "name": {
            "lang_1": "Egyedileg tervezett",
            "lang_2": "Individually designed"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 280000
          },
          "collections": ["firstHome", "dreamHome"],
          "gallery": [{
            "image_url": "https://configurator.studioarkitekter.com/demo/thumb_black.jpg"
          }],
          "layer": []
        }]
      }, {
        "key": "kitchen-pig",
        "name": {
          "lang_1": "Konyhamalac",
          "lang_2": "Kitchen pig"
        },
        "description": {
          "lang_1": "Szeretne konyhamalacot a konyhájába?",
          "lang_2": "Do you want a kitchen pig in your kitchen?"
        },
        "options": [{
          "key": "no",
          "name": {
            "lang_1": "Nem szeretnék",
            "lang_2": "No, I don't"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 0
          },
          "collections": ["basic", "firstHome"],
          "gallery": [],
          "layer": []
        }, {
          "key": "yes",
          "name": {
            "lang_1": "Igen, szeretnék",
            "lang_2": "Yes, I want it"
          },
          "description": {
            "lang_1": "Magyar szöveg, sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
            "lang_2": "English text, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
          },
          "price": {
            "lang_1": 280000
          },
          "collections": ["dreamHome"],
          "gallery": [],
          "layer": []
        }]
      }]
    }]
  }, {
    "key": "loft",
    "name": {
      "lang_1": "Loft",
      "lang_2": "Loft"
    },
    "description": {
      "lang_1": "Loft stílus, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
      "lang_2": "Loft design, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
    },
    "content": {
      "lang_1": "Hosszú szöveg lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      "lang_2": "Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },
    "price": {
      "lang_1": 89000000
    },
    "gallery": [{
      "image_url": "https://configurator.studioarkitekter.com/demo/loft_gallery_0.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/loft_gallery_1.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/loft_gallery_2.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/floorplan.jpg"
    }],
    "gallery_index_for_summary": 3
  }, {
    "key": "arkideko",
    "name": {
      "lang_1": "Arkideko",
      "lang_2": "Arkideko"
    },
    "description": {
      "lang_1": "Arkideko stílus, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
      "lang_2": "Arkideko design, lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
    },
    "content": {
      "lang_1": "Hosszú szöveg lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      "lang_2": "Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Long text lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
    },
    "price": {
      "lang_1": 99000000
    },
    "gallery": [{
      "image_url": "https://configurator.studioarkitekter.com/demo/arkideko_gallery_0.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/arkideko_gallery_1.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/arkideko_gallery_2.jpg"
    }, {
      "image_url": "https://configurator.studioarkitekter.com/demo/floorplan.jpg"
    }],
    "gallery_index_for_summary": 3
  }]
};
var _default = defaultAppData;
exports["default"] = _default;